var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-progress"},[_c('v-progress-circular',{attrs:{"color":_vm.color,"width":_vm.width,"size":_vm.size,"rotate":"270","value":_vm.progress,"indeterminate":_vm.isAnimateProgress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }